<template>
    <div id="login">
        <div class="login_header">
            Войти в личный кабинет
        </div>

        <auth-form />

        <div class="login_footer">
            Сделано на <a href="https://fitbase.io">fitbase.io</a>
        </div>
    </div>
</template>

<script>
    import AuthForm from "../components/AuthForm";

    export default {
        name: 'Login',
        components: { AuthForm }
    }
</script>
